import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { fieldValueInStorage, formDataInStorage, readDfStorage, saveToDfStorage } from "../../services/helperLib";
import { parseCurrencyToInt, formatCurrency } from "../../services/validation";
import { useState, useEffect, useCallback, useRef } from "react";
import Slider from "./Slider";
var minPercent = 0;
var maxPercent = 80;
var defaultPercent = 20;
export default function DownPayment(_a) {
    var _b, _c;
    var field = _a.field, onChange = _a.onChange, onBlur = _a.onBlur;
    var df = formDataInStorage();
    var loanAmtKey = Object.keys(df).find(function (k) { return k.endsWith("loanAmt_P"); });
    var rawLoanVal = (loanAmtKey && fieldValueInStorage(loanAmtKey)) || readDfStorage("loanAmt_P") || 0;
    var loanAmount = parseCurrencyToInt(rawLoanVal);
    var prevSavedLoan = parseCurrencyToInt((_b = readDfStorage("prevLoanAmt_P")) !== null && _b !== void 0 ? _b : 0);
    var storedPercent = Number((_c = readDfStorage("".concat(field.config.fieldId, "percent"))) !== null && _c !== void 0 ? _c : defaultPercent);
    var _d = useState(defaultPercent), percent = _d[0], setPercent = _d[1];
    var _e = useState(0), amount = _e[0], setAmount = _e[1];
    var prevLoanAmt = useRef(loanAmount);
    useEffect(function () {
        var loanChanged = loanAmount > 0 && loanAmount !== prevSavedLoan;
        if (loanChanged) {
            var resetPercent = defaultPercent;
            var resetAmount = Math.round((loanAmount * resetPercent) / 100);
            setPercent(resetPercent);
            setAmount(resetAmount);
            saveToDfStorage("".concat(field.config.fieldId, "percent"), resetPercent);
            saveToDfStorage("".concat(field.config.fieldId, "loanamt"), loanAmount);
            saveToDfStorage("prevLoanAmt_P", loanAmount);
        }
        else if (loanAmount > 0) {
            var amt = Math.round((loanAmount * storedPercent) / 100);
            setPercent(storedPercent);
            setAmount(amt);
        }
    }, [loanAmount, storedPercent, field.config.fieldId]);
    useEffect(function () {
        var t = setTimeout(function () { return onChange(formatCurrency(amount)); }, 100);
        return function () { return clearTimeout(t); };
    }, [amount, onChange]);
    var handleAmountChange = useCallback(function (e) {
        if (loanAmount <= 0)
            return;
        var v = e.target.value.replace(/[^0-9]/g, "");
        var n = v === "" ? 0 : parseInt(v, 10);
        var maxAmt = Math.round((loanAmount * maxPercent) / 100);
        n = Math.min(n, maxAmt);
        var newPct = Math.round((n / loanAmount) * 100);
        setAmount(n);
        setPercent(Math.max(minPercent, Math.min(newPct, maxPercent)));
        saveToDfStorage("".concat(field.config.fieldId, "percent"), newPct);
    }, [loanAmount, field.config.fieldId]);
    var handlePercentChange = useCallback(function (e) {
        if (loanAmount <= 0)
            return;
        var v = e.target.value.replace(/[^0-9]/g, "");
        var p = v === "" ? 0 : parseInt(v, 10);
        p = Math.max(minPercent, Math.min(p, maxPercent));
        var newAmt = Math.round((loanAmount * p) / 100);
        setPercent(p);
        setAmount(newAmt);
        saveToDfStorage("".concat(field.config.fieldId, "percent"), p);
    }, [loanAmount, field.config.fieldId]);
    var handleSliderChange = useCallback(function (e) {
        if (loanAmount <= 0)
            return;
        var p = parseInt(e.target.value, 10);
        var newAmt = Math.round((loanAmount * p) / 100);
        setPercent(p);
        setAmount(newAmt);
        saveToDfStorage("".concat(field.config.fieldId, "percent"), p);
    }, [loanAmount, field.config.fieldId]);
    return (_jsxs("div", { className: "down-payment", children: [_jsx("label", { htmlFor: "dpAmount", className: "visually-hidden", children: "Down Payment Amount" }), _jsxs("div", { className: "down-payment-fields", children: [_jsx("input", { id: "dpAmount", className: "down-payment-amount", type: "text", value: formatCurrency(amount), onChange: handleAmountChange, onBlur: onBlur, inputMode: "numeric", autoComplete: "off" }), _jsx("label", { htmlFor: "dpPercentage", className: "visually-hidden", children: "Down Payment Percentage" }), _jsx("input", { id: "dpPercentage", className: "down-payment-percentage", type: "text", value: "".concat(percent, "%"), onChange: handlePercentChange, onBlur: onBlur, inputMode: "numeric", autoComplete: "off" })] }), field.config.includeSlider && (_jsx(Slider, { value: percent, step: 1, min: minPercent, max: maxPercent, onChange: handleSliderChange }))] }));
}
